module.exports = __webpack_public_path__ + "media/images/pic/anime/bookworm-b93c08d9dcba931de8e324f1efe8e432.svg";